import { Link } from "react-router-dom";
import { usePageTitle } from "../components/usePageTitle";
import { programs } from "../content/site";

export default function Events() {
  usePageTitle("Events");
  return (
    <>
      <section className="page-head page-head-photo" style={{ backgroundImage: "url(/images/football.jpg)" }}>
        <div className="wrap narrow center">
          <h1 className="display">the buzz @ platform 18</h1>
          <p className="section-title">Cool and inspiring events on our calendar. Hint: you should add them to yours.</p>
        </div>
      </section>

      <section className="band">
        <div className="wrap">
          <ul className="programs" role="list">
            {programs.map((p) => (
              <li key={p.title} className="program">
                <p className="label">{p.when}</p>
                <h2>{p.title}</h2>
                <Link className="text-link" to="/contact">
                  Ask about the next one
                </Link>
              </li>
            ))}
          </ul>
          <p className="center muted">
            Want to request, create or host an event? <Link to="/contact">Tell us about it.</Link>
          </p>
        </div>
      </section>

      <section className="band band-tint">
        <div className="wrap split">
          <img className="rounded" src="/images/people-trip.jpg" alt="A Platform 18 group on a trip" width="839" height="506" loading="lazy" />
          <div>
            <h2 className="display">
              memorable cookouts, <em>unforgettable trips</em>
            </h2>
            <p className="lede">
              Take part in events that will enrich, intrigue, and challenge you. Plus, the chance to request, create or host
              the events YOU want.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
